module.exports = __webpack_public_path__ + "static/img/bannermanitos892x112.1cb30ee4.png";